import { render, staticRenderFns } from "./child.vue?vue&type=template&id=b78a2a6a&scoped=true&"
import script from "./child.vue?vue&type=script&lang=js&"
export * from "./child.vue?vue&type=script&lang=js&"
import style0 from "./child.vue?vue&type=style&index=0&lang=css&"
import style1 from "./child.vue?vue&type=style&index=1&id=b78a2a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78a2a6a",
  null
  
)

export default component.exports